import { Injectable } from '@angular/core';
import { BaseApi } from './_base-api';
import { PermissionEntity, RoleCreate, RoleDetails, RoleEntity, RoleUpdate } from '../models';

@Injectable({
  providedIn: 'root'
})
export class RoleApiService extends BaseApi<RoleEntity> {
  constructor() {
    super('', {
      get: '/Role/admin/GetRoleList'
    });
  }

  getDetails(id: number) {
    return http$.get<RoleDetails>(`/Role/admin/GetRole?RoleId=${id}`);
  }

  createRole(model: RoleCreate) {
    return http$.post('/Role/admin/CreateRole', model);
  }

  updateRole(id: number, model: RoleUpdate) {
    return http$.put('/Role/admin/EditRole', { roleId: id, ...model });
  }

  getPermissions() {
    return http$.get<PermissionEntity[]>('/Role/admin/GetPermissionList');
  }

  getRoleItems() {
    return this.getItemRecords(role => role.name, false);
  }

}
